<div class="actionType-tree" (click)="$event.stopPropagation();">
    <div id="activity-type-tree" #activityTypeTree></div>
</div>